import createSurveyForm from 'utils/createSurveyForm';

export const FORM = 'activitySurveyAddForm';

const ActivitySurveyAddForm = createSurveyForm(FORM);

export default ActivitySurveyAddForm;
